import { createContext, useContext } from 'react';

const OrganisationSearchContext = createContext({
    organisationSearch: '',
});

export const useOrganisationSearch = () =>
    useContext(OrganisationSearchContext);

export default OrganisationSearchContext;
